import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../endpoints";
import { getResource } from "../https";
import { Category, SubCategory, SubSubCategory } from "../types";
import { querykeys } from "../querykeys";

interface CategoryResponse {
  data: Category[];
}

interface SubCategoryResponse {
    data: SubCategory[];
}

interface SubSubCategoryResponse {
    data: SubSubCategory[];
}

export const getCategories = async (): Promise<CategoryResponse> => {
  return await getResource({
    pathUrl: `${endpoints.products}/categories`,
  });
};

export const getSubCategories = async (categoryId: string): Promise<SubCategoryResponse> => {
    return await getResource({
      pathUrl: `${endpoints.products}/subcategories?categoryId=${categoryId}`,
    });
};

export const getSubSubCategories = async (subCategoryId: string): Promise<SubSubCategoryResponse> => {
    return await getResource({
      pathUrl: `${endpoints.products}/subsubcategories?subcategoryId=${subCategoryId}`,
    });
};

export const useGetAllCategories = () => {
    const query = useQuery({
      queryKey: [querykeys.GET_CATEGORIES],
      queryFn: () => getCategories(),
    });
    return query;
};

export const useGetAllSubCategories = (categoryId: string) => {
    const query = useQuery({
      queryKey: [querykeys.GET_SUB_CATEGORIES, categoryId],
      queryFn: () => getSubCategories(categoryId),
    });
    return query;
};

export const useGetAllSubSubCategories = (subCategoryId: string) => {
    const query = useQuery({
      queryKey: [querykeys.GET_SUB_SUB_CATEGORIES, subCategoryId],
      queryFn: () => getSubSubCategories(subCategoryId),
    });
    return query;
};